import Layout from '@/layout'

export default {
  path: '/settlement',
  component: Layout,
  name: 'settlement',
  meta: {
    title: '结算管理',
    role: 1552,
    icon: 'settle'
  },
  children: [
    {
      path: 'apply-list',
      name: 'SettlementApplyList',
      component: () => import('@/pages/settlement/apply-list'),
      meta: { title: '结算申请', role: 1553 }
    },
    {
      path: 'apply-detail/:orgId',
      name: 'SettlementApplyDetail',
      hidden: true,
      component: () => import('@/pages/settlement/apply-detail'),
      meta: { title: '结算申请详情', role: 1553, noCache: true }
    },
    {
      path: 'list',
      name: 'SettlementList',
      component: () => import('@/pages/settlement/list'),
      meta: { title: '结算单列表', role: 1554 }
    },
    {
      path: 'detail/:id',
      name: 'SettlementDetail',
      hidden: true,
      component: () => import('@/pages/settlement/detail'),
      meta: { title: '结算单详情', role: 1554, noCache: true }
    },
    {
      path: 'wait-list',
      name: 'SettlementWaitList',
      component: () => import('@/pages/settlement/wait-list'),
      meta: { title: '订单补退', role: 1621 }
    },
    {
      path: 'wait-detail/:id',
      name: 'SettlementWaitDetail',
      hidden: true,
      component: () => import('@/pages/settlement/wait-detail'),
      meta: { title: '订单补退详情', role: 1621, noCache: true }
    }
  ]
}
